import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../components/Component";

const RABillAside = ({ updateSm, sm }: any) => {
  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">RA Bills</span>
            <span className="sub-text">
              Manage Running Account Bills creation, approvals, and payment tracking
            </span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-create`}
              onClick={() => updateSm(false)}
            >
              <Icon name="plus-circle" />
              <span>Create RABills</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-pending-approvals`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-round" />
              <span>Pending Approvals</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-view-approved`}
              onClick={() => updateSm(false)}
            >
              <Icon name="eye" />
              <span>View RABills</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-outstanding`}
              onClick={() => updateSm(false)}
            >
              <Icon name="clock" />
              <span>Outstanding RABills</span>
            </Link>
          </li>
          <li>
            <Link
              to={`${process.env.PUBLIC_URL}/ra-bills-overdue`}
              onClick={() => updateSm(false)}
            >
              <Icon name="alert-circle" />
              <span>Overdue RABills</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default RABillAside;